import { render, staticRenderFns } from "./AddressForm.vue?vue&type=template&id=c897ec84"
import script from "./AddressForm.vue?vue&type=script&lang=js"
export * from "./AddressForm.vue?vue&type=script&lang=js"
import style0 from "./AddressForm.vue?vue&type=style&index=0&id=c897ec84&prod&lang=css"
import style1 from "./AddressForm.vue?vue&type=style&index=1&id=c897ec84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports